module.exports = __webpack_public_path__ + "static/media/claim-zh-Hans.3b6d0dec.png";